import { fontWeight } from "@mui/system";
import moment from "moment";
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { BaseProps } from "../move-inRegistrationTabs/interfaces";

import { InputContainer, Table } from "../MoveOutTerminationTabs/MoveOut.styled";
import General from '../../stores/GeneralStore'
import { observer } from "mobx-react";
import { InfoContainer, TabContainer } from "../move-inRegistrationTabs/move-inTabs.styled";
import paymentPlanStore from '../../stores/PaymentPlanStore'
import { Label } from "../../../src/screens/complaint/Complaint.styled";
import NocsRequests from "../../stores/NocsRequestsStore";
import { toJS } from "mobx";
import User from "../../stores/UserStore";
import { Spinner, SpinnerRaw } from "../../components/SpinnerRaw/SpinnerRaw";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { Modal, TextField, TextFieldProps } from "@mui/material";
import { Box } from "@mui/system";

interface Obj {
  [key: string]: string | {} | [];
}



interface Props extends BaseProps {
  pdcDetails: Obj,
  serviceAccounts: Obj[],
  connectorAccounts: Obj[],
  onClose: () => void,
  payNowClicked: () => void,
  Submit: (data: any) => Promise<void>;
  getPDCServiceAccountList: (caseNo: string) => Promise<void>,
  getPDCConnectorAccountList: (caseNo: string) => Promise<void>,
  saveloader:Boolean,
}


const AccountsTable = ({ accounts }: { accounts: Obj[] }) => {
  const ColorAss = General?.ColorAss;
  const contrast=General?.contrast;
  return <div style={{ width: '100%' }}>
    <Table lastChild={true} beforeLastChild={true}>

      <thead>
        <tr style={{color:contrast?.contrastColor?contrast?.contrastColor:'',}}>
          <th style={{}}>
            {General?.codeLabels["cm_accountnopaymentstable"]?.label !== undefined ? General?.codeLabels["cm_accountnopaymentstable"]?.label : "Account Number"}
          </th>
          <th style={{}}>
            {General?.codeLabels["cm_acctype"]?.label !== undefined ? General?.codeLabels["cm_acctype"]?.label : "Account Type"}
          </th>
          <th style={{}}>

            {General?.codeLabels["cm_pdc_accountgroup"]?.label !== undefined ? General?.codeLabels["cm_pdc_accountgroup"]?.label : "Account Group"}

          </th>
          <th style={{}}>
            {General?.codeLabels["cm_premiseid"]?.label !== undefined ? General?.codeLabels["cm_premiseid"]?.label : "Sewerage Number"}
          </th>
          <th style={{}}>
            {General?.codeLabels["cm_pdc_premisedetails"]?.label !== undefined ? General?.codeLabels["cm_pdc_premisedetails"]?.label : "Premise Details"}
          </th>
          <th style={{}}>            {General?.codeLabels["cm_dpremiseusage"]?.label !== undefined ? General?.codeLabels["cm_dpremiseusage"]?.label : "Premise Usage"}
          </th>
          <th style={{}}>{General?.codeLabels["cm_amt_due"]?.label !== undefined ? General?.codeLabels["cm_amt_due"]?.label : "Amount Due"}</th>
        </tr>
      </thead>

      <tbody>

        {
          accounts.map((account) => {
            return <tr style={{color:contrast?.contrastColor?contrast?.contrastColor:'',}}>
              <td>{account.accountId as string}</td>
              <td>{account.accountType as string}</td>
              <td>{account.accountGroup as string}</td>
              <td>{account.sewerageNo as string}</td>
              <td>{account.premiseDetails as string}</td>
              <td>{account.premiseUsage as string}</td>
              <td>{account.amountDue as string}</td>
            </tr>
          })

        }

      </tbody>
    </Table>
  </div>

}




const PDCModal = ({saveloader,Submit, payNowClicked, onClose, pdcDetails, getPDCServiceAccountList, getPDCConnectorAccountList, serviceAccounts, connectorAccounts }: Props) => {

  const [chequesTotal, setChequesTotal] = useState<number>(0)
  const [rawDate, setrawDate] = useState<any>("")

 

  const [serviceExpanded, setServiceExpanded] = useState<boolean>(false)
  const [connectorExpanded, setConnectorExpanded] = useState<boolean>(false)
  const cheque1 = useRef<HTMLInputElement | null>(null);
  const accountNumber1 = useRef<HTMLInputElement | null>(null);
  const accountName1 = useRef<HTMLInputElement | null>(null);
  const bankName1 = useRef<HTMLSelectElement | null>(null);

const [cheqval1,setceque1]=useState("");
const [accNumberval1,setaccountNumber1]=useState("");
const [accNameval1,setaccountName1]=useState("");
const [accBankVal1,setBankVal1]=useState("");

const [cheqval2,setceque2]=useState("");
const [accNumberval2,setaccountNumber2]=useState("");
const [accNameval2,setaccountName2]=useState("");
const [accBankVal2,setBankVal2]=useState("");

  const cheque2 = useRef<HTMLInputElement | null>(null);
  const accountNumber2 = useRef<HTMLInputElement | null>(null);
  const accountName2 = useRef<HTMLInputElement | null>(null);
  const bankName2 = useRef<HTMLSelectElement | null>(null);
  const checkDetails: Obj[] = pdcDetails.checkDetails as []
  let rawObject = Object.entries(checkDetails)[0][1]
 
  

  useEffect(() => {
     setrawDate(rawObject.checkDate) ;
     localStorage.removeItem('pdcId');
    }, [rawObject.checkDate])
  let date = new Date(rawDate);



  const getTotal = () => {
    let sum = 0

    for (let i = 0; i < checkDetails.length; i++) {
      sum += checkDetails[i].checkAmount as number
    }

    setChequesTotal(sum)
  }

  const handlePayNow = () => {

    payNowClicked()
  }


  useLayoutEffect(() => {
    getTotal()
  }, [checkDetails])
  const[checkDetailspayload,setcheckDetailspayload]=useState<any>();
  useEffect(()=>{
    getPDCServiceAccountList(pdcDetails.caseNo as string)
    getPDCConnectorAccountList(pdcDetails.caseNo as string)
    setcheckDetailspayload(pdcDetails?.checkDetails);
  },[])

  const handleGetPDCServiceAccountList = () => {
    if (serviceExpanded)
      setServiceExpanded(false)
    else {
      setServiceExpanded(true)
    }

  }

  const handleGetPDCConnectorAccountList = () => {
    if (connectorExpanded)
      setConnectorExpanded(false)
    else {
      setConnectorExpanded(true)
    }
  }
  

  const createdDate=moment(pdcDetails.createdDate).format("YYYY-MM-DD");
  const specificDate = moment(createdDate);
const allowedMinDate = specificDate.clone().subtract(0, 'days').toDate();
const allowedMaxDate = specificDate.clone().add(60, 'days').toDate();

const allowedMinDate2 = specificDate.clone().add(60, 'days').toDate();
const allowedMaxDate2 = specificDate.clone().add(120, 'days').toDate();
const [fromValue2, setFromValue2] = useState<any | null>(moment(allowedMinDate2).format("YYYY / MM / DD"));
const [fromValue, setFromValue] = useState<any | null>(moment(pdcDetails.createdDate).format("YYYY / MM / DD"));

const handleFromChange = (newVal: Date | null,index:any) => {
  if(index=='0'){
    setFromValue(newVal);
  }else{
    setFromValue2(newVal)
  }
  
};
  const handleChange = (e:any, fieldToUpdate:any, index:any) => {
   if(fieldToUpdate=='checkDate'){
    if(index=='0'){
      setFromValue(e);
    }else{
      setFromValue2(e)
    }
   }
    const updatedCheck = [...checkDetailspayload]
    switch (fieldToUpdate) {
      case 'checkNo':
        updatedCheck[index].checkNo = e.target.value;
        break;
      case 'checkDate':
        updatedCheck[index].checkDate= moment(e).format("YYYY-MM-DD");
        break;
      case 'payorAccountNo':
        updatedCheck[index].payorAccountNo = e.target.value;
        break;
      case 'payorAccountName':
        updatedCheck[index].payorAccountName = e.target.value;
        break;
      case 'bankName':
        updatedCheck[index].bankCode = e.target.value;
        updatedCheck[index].bankName = paymentPlanStore?.bankDetails.find((bank:any)=>bank?.bankCode==e.target?.value).bankName;
        break;
      default:
        break;
    }
    updatedCheck[index].isActive=true;
    // Update the specific check object in the copied array
    console.log(toJS(updatedCheck[index]));
  
    // Update the state with the updated array
    // console.log(toJS(updatedCheckDetails))
    setcheckDetailspayload(updatedCheck);
  };
  const handleSave=()=>{
  
    const data={

    checkDetails:checkDetailspayload,personId:User.info.personId,caseNo:pdcDetails.caseNo,corelationID:pdcDetails?.corelationID
  }
    Submit(data)
  }
  const ColorAss = General?.ColorAss;
  const contrast=General?.contrast;
  return (
    <div style={{ margin: "3rem" ,direction:General?.codeLabels["cm_pdc_paymentaccounts"]?.languageCode =="ARA"? "rtl": "ltr",}}>
      <div
        style={{
          backgroundColor: contrast?.contrastColor
            ? contrast?.contrastColor
            : "#101e8e",
          padding: 15,
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <h1
          id="modal-title"
          style={{
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "white",
            margin: 0,
            fontSize: `${2 * General.accessibility.fontSize}rem`,
          }}
        >
          {General?.codeLabels["cm_payment_case"]?.label
            ? General?.codeLabels["cm_payment_case"]?.label
            : "PDC Payment Case"}
          : {pdcDetails.caseNo as string}
        </h1>
        <span
          style={{
            fontSize: `${2 * General.accessibility.fontSize}rem`,
            cursor: "pointer",
            color: contrast?.contrastBackground
              ? contrast?.contrastBackground
              : "white",
          }}
          onClick={onClose}
        >
          x
        </span>
      </div>

      <div
        style={{
          overflowY: "auto",
          backgroundColor: contrast?.contrastBackground
            ? contrast?.contrastBackground
            : "#fff",
          padding: "30px",
          color: "#101E8E",
          height: "80vh",
        }}
      >
        <div
          style={{
            marginBottom: "2rem",
            display: "flex",
            width: "100%",
            justifyContent: "space-between",
            flexDirection: "column",
          }}
        >
          <div style={{ display: "flex", flexDirection: "column" }}>
            <div style={{ fontWeight: "bold", fontSize: "1rem" }}>
              <div
                style={{
                  marginBottom: "2rem",
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <div style={{ display: "flex", flexDirection: "column" }}>
                  <div
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                      fontWeight: "bold",
                      fontSize: `${General.accessibility.fontSize}rem`,
                    }}
                  >
                    {General?.codeLabels["cm_pdctablecreateddate"]?.label !==
                    undefined
                      ? General?.codeLabels["cm_pdctablecreateddate"]?.label
                      : "Created Date"}
                  </div>
                  <div
                    style={{
                      fontSize: `${1.125 * General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                  >
                    {moment(pdcDetails.createdDate as string).format(
                      "DD MMM YYYY"
                    )}
                  </div>
                </div>

                <div
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  {General?.codeLabels["cm_pdc_makaninumber"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_pdc_makaninumber"]?.label
                    : "Makani Number"}

                  <div
                    style={{
                      fontSize: `${1.125 * General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                  >
                    {pdcDetails.makaniNumber as string}
                  </div>
                </div>

                <div
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                      fontWeight: "bold",
                      fontSize: `${General.accessibility.fontSize}rem`,
                    }}
                  >
                    {General?.codeLabels["cm_asreqstatustable"]?.label
                      ? General?.codeLabels["cm_asreqstatustable"]?.label
                      : "Status"}
                  </div>
                  <div
                    style={{
                      fontSize: `${1.125 * General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                  >
                    {pdcDetails.statusName as string}
                  </div>
                </div>

                <div
                  style={{
                    color: contrast?.contrastColor
                      ? contrast?.contrastColor
                      : "",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <div
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                      fontWeight: "bold",
                      fontSize: `${General.accessibility.fontSize}rem`,
                    }}
                  >
                    {General?.codeLabels["cm_pd_authorize"]?.label
                      ? General?.codeLabels["cm_pd_authorize"]?.label
                      : "Authorised Signatory"}
                  </div>
                  <div
                    style={{
                      fontSize: `${1.125 * General.accessibility.fontSize}rem`,
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                  >
                    {pdcDetails.payorAuthorizedSignatory as string}
                  </div>
                </div>
              </div>
            </div>

            <div
              style={{
                color: contrast?.contrastColor ? contrast?.contrastColor : "",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ fontWeight: "bold", fontSize: "1rem" }}>
                {/* {General?.codeLabels["cm_noc_status"]?.label !== undefined ? General?.codeLabels["cm_noc_status"]?.label : "Status"} */}
              </div>
              {/* <div style={{ fontSize: '1.125rem' }}>{pdcDetails.statusName as string}</div> */}
            </div>

            <div
              style={{
                color: contrast?.contrastColor ? contrast?.contrastColor : "",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {/* <div style={{ fontWeight: 'bold', fontSize: '1rem' }}>Authorised Signatory</div> */}
              {/* <div style={{ fontSize: '1.125rem' }}>{pdcDetails.payorAuthorizedSignatory as string}</div> */}
            </div>
          </div>

          <Table>
            <thead
              style={{
                color: contrast?.contrastColor ? contrast?.contrastColor : "",
                backgroundColor: contrast?.contrastBackground
                  ? contrast?.contrastBackground
                  : "",
              }}
            >
              <tr
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                }}
              >
                <th style={{}}>
                  {General?.codeLabels["cm_pdcpaymentaccounts"]?.label
                    ? General?.codeLabels["cm_pdcpaymentaccounts"]?.label
                    : "Accounts"}
                </th>
                <th
                  style={{
                    textAlign: "right",
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  }}
                >
                  <th style={{ textAlign: "right" }}>
                    {General?.codeLabels["cm_pdc_amount"]?.label !== undefined
                      ? General?.codeLabels["cm_pdc_amount"]?.label
                      : "Amount"}{" "}
                    (AED)
                  </th>
                </th>
                <th
                  style={{
                    textAlign: "center",
                    width: "5rem",
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  }}
                ></th>
              </tr>
            </thead>
            <tbody>
              <tr
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                }}
              >
                <td>
                  {General?.codeLabels["cm_nocf_svce"]?.label !== undefined
                    ? General?.codeLabels["cm_nocf_svce"]?.label
                    : "Service Fee"}
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  }}
                >
                  {pdcDetails.serviceTotalDue as string}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    cursor: "pointer",
                    fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                  }}
                  onClick={handleGetPDCServiceAccountList}
                >
                  {serviceExpanded ? "-" : "+"}
                </td>
              </tr>
              {serviceExpanded ? (
                serviceAccounts.length > 0 ? (
                  <AccountsTable accounts={serviceAccounts} />
                ) : (
                  <p
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                  >
                    {General?.codeLabels["cm_pdcpaymentaccounts"]?.label
                      ? General?.codeLabels["cm_pdcpaymentaccounts"]?.label
                      : "No Data "}
                  </p>
                )
              ) : null}
              <tr
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                }}
              >
                <td
                  style={{
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  }}
                >
                  {General?.codeLabels["cm_connectio_fee"]?.label
                    ? General?.codeLabels["cm_connectio_fee"]?.label
                    : "Connection-Fee Connected"}
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  }}
                >
                  {pdcDetails.connectedTotalDue as string /*connectorTotalDue*/}
                </td>
                <td
                  style={{
                    textAlign: "center",
                    cursor: "pointer",
                    fontSize: `${1.5 * General.accessibility.fontSize}rem`,
                  }}
                  onClick={handleGetPDCConnectorAccountList}
                >
                  {connectorExpanded ? "-" : "+"}
                </td>
              </tr>
              {connectorExpanded ? (
                connectorAccounts.length > 0 ? (
                  <AccountsTable accounts={connectorAccounts} />
                ) : (
                  <p>
                    {General?.codeLabels["cm_pdc_emptytable"]?.label
                      ? General?.codeLabels["cm_pdc_emptytable"]?.label
                      : "No data"}
                  </p>
                )
              ) : null}
              <tr
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                }}
              >
                <td
                  style={{
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  }}
                >
                  {General?.codeLabels["cm_pdc_advanceservicecharge"]?.label
                    ? General?.codeLabels["cm_pdc_advanceservicecharge"]?.label
                    : "Advance Service Charges"}
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  }}
                >
                  {pdcDetails.advanceAmount as string}
                </td>
                <td></td>
              </tr>
              <tr
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                }}
              >
                <td
                  style={{
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                    fontWeight: "bold",
                  }}
                >
                  {General?.codeLabels["cm_total_amt"]?.label !== undefined
                    ? General?.codeLabels["cm_total_amt"]?.label
                    : "Total Amount"}
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  }}
                >
                  {pdcDetails.totalAmount as string}
                </td>
                <td></td>
              </tr>
              <tr
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                }}
              >
                <td
                  style={{
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                  }}
                >
                  {General?.codeLabels["cm_pdc_current_pay_amount"]?.label !==
                  undefined
                    ? General?.codeLabels["cm_pdc_current_pay_amount"]?.label
                    : "Current Payment Amount"}
                </td>
                <td
                  style={{
                    textAlign: "right",
                    fontSize: `${0.875 * General.accessibility.fontSize}rem`,
                    fontWeight: "lighter",
                  }}
                >
                  {pdcDetails.currentAmount as string}
                </td>
                <td></td>
              </tr>
            </tbody>
          </Table>

          {pdcDetails.statusName != "Pending Check Submission" && (
            <>
              <p
                style={{
                  color: contrast?.contrastColor ? contrast?.contrastColor : "",
                  fontSize: "1.3rem",
                  fontWeight: "bold",
                  marginTop: "10px",
                }}
              >
                {General?.codeLabels["cm_pdc_chequedetails"]?.label !==
                undefined
                  ? General?.codeLabels["cm_pdc_chequedetails"]?.label
                  : "Cheque Details"}
              </p>
              <Table>
                <thead>
                  <tr
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                  >
                    <th
                      style={{
                        fontSize: `${
                          0.875 * General.accessibility.fontSize
                        }rem`,
                      }}
                    >
                      {General?.codeLabels["cm_pdc_checknumber"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_pdc_checknumber"]?.label
                        : "Cheque Number"}
                    </th>

                    <th
                      style={{
                        fontSize: `${
                          0.875 * General.accessibility.fontSize
                        }rem`,
                      }}
                    >
                      {General?.codeLabels["cm_pdc_chequedate"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_pdc_chequedate"]?.label
                        : "Cheque Date"}
                    </th>
                    <th
                      style={{
                        fontSize: `${
                          0.875 * General.accessibility.fontSize
                        }rem`,
                      }}
                    >
                      {General?.codeLabels["cm_bankname"]?.label !== undefined
                        ? General?.codeLabels["cm_bankname"]?.label
                        : "Bank Name"}
                    </th>
                    <th
                      style={{
                        fontSize: `${
                          0.875 * General.accessibility.fontSize
                        }rem`,
                      }}
                    >
                      {General?.codeLabels["cm_pdc_chequeamount"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_pdc_chequeamount"]?.label
                        : "Cheque Amount"}
                    </th>
                  </tr>
                </thead>

                {checkDetails.map((cheque: any, index: any) => {
                  // setrawDate(cheque.checkDate.toString())
                  return (
                    <tr
                      style={{
                        color: contrast?.contrastColor
                          ? contrast?.contrastColor
                          : "",
                      }}
                    >
                      <td
                        style={{
                          fontSize: `${
                            0.875 * General.accessibility.fontSize
                          }rem`,
                        }}
                      >
                        {cheque?.checkNo
                          ? cheque?.checkNo
                          : `Cheque ${index + 1}`}
                      </td>
                      <td
                        style={{
                          fontSize: `${
                            0.875 * General.accessibility.fontSize
                          }rem`,
                        }}
                      >
                        {moment(cheque?.checkDate).format("DD MMMM YYYY")}
                      </td>

                      <td
                        style={{
                          fontSize: `${
                            0.875 * General.accessibility.fontSize
                          }rem`,
                        }}
                      >
                        {cheque?.bankName}
                      </td>

                      <td
                        style={{
                          fontSize: `${
                            0.875 * General.accessibility.fontSize
                          }rem`,
                        }}
                      >
                        {cheque.checkAmount as string}
                      </td>
                    </tr>
                  );
                })}

                {
                  <tr
                    style={{
                      color: contrast?.contrastColor
                        ? contrast?.contrastColor
                        : "",
                    }}
                  >
                    <td
                      style={{
                        fontSize: `${1 * General.accessibility.fontSize}rem`,
                        fontWeight: "bolder",
                        background: "rgba(229,239,242,0.7)",
                      }}
                    >
                      {General?.codeLabels["cm_pdc_totalcheckamount"]?.label !==
                      undefined
                        ? General?.codeLabels["cm_pdc_totalcheckamount"]?.label
                        : "Total Cheque Amount"}
                    </td>
                    <td style={{ background: "rgba(229,239,242,0.7)" }}></td>
                    <td style={{ background: "rgba(229,239,242,0.7)" }}></td>
                    <td
                      style={{
                        fontWeight: "bold",
                        background: "rgba(229,239,242,0.7)",
                      }}
                    >
                      {chequesTotal}
                    </td>
                  </tr>
                }
              </Table>
            </>
          )}
        </div>

        {pdcDetails.statusName == "Payment Pending" ? (
          <button
            style={{
              fontSize: `${General.accessibility.fontSize}rem`,
              border: "0",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "rgb(16, 30, 142)",
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "white",
              padding: "4px 10px",
            }}
            onClick={handlePayNow}
          >
            PAY NOW
          </button>
        ) : null}

        {pdcDetails.statusName == "Pending Check Submission" && (
          <>
            {checkDetails &&
              checkDetails?.map((check: any, index: any) => (
                <InfoContainer
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Label style={{ width: "25%" }}>
                    {General?.codeLabels["cm_pdcchequedate"]?.label
                      ? General?.codeLabels["cm_pdcchequedate"]?.label
                      : "Cheque Number"}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                        gap: {
                          xs: "29px",
                          md: "0px",
                        },
                      }}
                    >
                    
                      <LocalizationProvider dateAdapter={AdapterMoment}>
                        <MobileDatePicker
                          // disableFuture={true}
                          // className="calendar-style"
                          inputFormat="YYYY / MM / DD"
                          // value={'2023/01/01'}
                          value={index==0? fromValue:fromValue2}
                          onChange={(e)=>handleChange(e, "checkDate", index)}
                          minDate={index==0? allowedMinDate:allowedMinDate2}
                          maxDate={index==0? allowedMaxDate:allowedMaxDate2}
                          renderInput={(params: TextFieldProps) => {
                            return (
                              <TextField
                                className="text-field-cal"
                                {...params}
                              />
                            );
                          }}
                        />
                      </LocalizationProvider>
                    </Box>
                    {/* <div>{moment(check.checkDate as string).format('DD MMM YYYY')}</div> */}
                  </Label>
                  <Label style={{ width: "25%" }}>
                    {General?.codeLabels["cm_pdc_checknumber"]?.label
                      ? General?.codeLabels["cm_pdc_checknumber"]?.label
                      : "Cheque Number"}
                    *
                    <input
                      onChange={(e) => handleChange(e, "checkNo", index)}
                      value={check?.checkNo}
                      ref={cheque1}
                      style={{ width: "100%", background: "#E5EFF2" }}
                    />
                  </Label>
                  <Label style={{ width: "25%" }}>
                    {General?.codeLabels["cm_accountid1"]?.label
                      ? General?.codeLabels["cm_accountid1"]?.label
                      : "Cheque Number"}
                    *
                    <input
                      value={check?.payorAccountNo}
                      onChange={(e) => handleChange(e, "payorAccountNo", index)}
                      ref={accountNumber1}
                      style={{ width: "100%", background: "#E5EFF2" }}
                    />
                  </Label>
                  <Label style={{ width: "25%" }}>
                    {General?.codeLabels["cm_pdc_accountname"]?.label
                      ? General?.codeLabels["cm_pdc_accountname"]?.label
                      : "Cheque Number"}
                    *
                    <input
                      value={check?.payorAccountName}
                      onChange={(e) =>
                        handleChange(e, "payorAccountName", index)
                      }
                      ref={accountName1}
                      style={{ width: "100%", background: "#E5EFF2" }}
                    />
                  </Label>
                  <Label style={{ width: "25%" }}>
                    {General?.codeLabels["cm_bankname"]?.label
                      ? General?.codeLabels["cm_bankname"]?.label
                      : "Cheque Number"}
                    *
                    <select
                      style={{ paddingLeft: "15px", color: "#101E8E" }}
                      onChange={(e) => handleChange(e, "bankName", index)}
                      ref={bankName1}
                    >
                      <option
                        style={{
                          fontSize: `${General.accessibility.fontSize}rem`,
                        }}
                        value=""
                        disabled
                        selected
                        hidden
                      >
                        {General?.codeLabels["cm_mob_select"]?.label !==
                        undefined
                          ? General?.codeLabels["cm_mob_select"]?.label
                          : "Select"}
                      </option>
                      {paymentPlanStore?.bankDetails?.map((details: any) => (
                        <option
                          style={{
                            fontSize: `${General.accessibility.fontSize}rem`,
                          }}
                          value={details.bankCode}
                        >
                          {details.bankName}
                        </option>
                      ))}
                    </select>
                  </Label>
                </InfoContainer>
              ))}
          </>
        )}
        {pdcDetails.statusName == "Pending Check Submission" ? (
          <button
            style={{
              fontSize: `${General.accessibility.fontSize}rem`,
              border: "0",
              background: contrast?.contrastColor
                ? contrast?.contrastColor
                : "rgb(16, 30, 142)",
              color: contrast?.contrastBackground
                ? contrast?.contrastBackground
                : "white",
              padding: "4px 10px",
            }}
            onClick={handleSave}
          >
            {saveloader ? (
              <Spinner width="30px" height="30px" />
            ) : (
              General?.codeLabels["cm_save"]?.label
            )}
          </button>
        ) : null}

        {/* {
          pdcDetails.statusName == 'Completed'
            ? <button onClick={handlePayNow}>
              {General?.codeLabels["cm_paynow"]?.label !== undefined ? General?.codeLabels["cm_paynow"]?.label : "Payed"}
            </button>
            : null
        } */}
      </div>
    </div>
  );
};

export default observer(PDCModal);